import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";
import { useKeysStore } from "../../../../core/store/useKeysStore";

function Form() {
    const { keys } = useKeysStore();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const profileFilter = chooseProfileFilter();

    const hiddenValues = {}

    if (profileFilter.pdc_entity_id) {
        hiddenValues.pdc_entity_id = profileFilter.pdc_entity_id
    }

    const path = '/announcements/';
    const paths = {
        endpointSave: config.endpoints.backend + 'announcements/save',
        endpointGetById: config.endpoints.backend + 'announcements/getById',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetAllAnnouncementCategories: config.endpoints.backend + 'announcementcategories/getall',

        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Novo Comunicado",
        labelTitleEdit: "Editar Comunicado",
        labelTitleView: 'Visualizar Comunicado'
    }

    const getForm = (values, options) => {
        let form = {
            validateOnChange: true,
            hiddenValues: {
                ...hiddenValues
            },
            fields: [
                !hiddenValues.pdc_entity_id ? {
                    name: 'pdc_entity_id',
                    type: 'select',
                    label: 'Entidade',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllEntities,
                        label: 'corporate_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 12,
                } : {},
                {
                    name: 'pdc_category_id',
                    type: 'select',
                    label: 'Categoria de comunicado',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllAnnouncementCategories,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                },
                {
                    name: 'announcement_code',
                    type: 'text',
                    label: 'Código do Comunicado',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'title',
                    type: 'text',
                    label: 'Título',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'publish_date',
                    type: 'date',
                    label: 'Data de Publicação',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'file',
                    type: 'fileS3',
                    extensionAccept: '.jpeg,.jpg,.png,.ico,.pdf,.xlsx,.docx',
                    limitFileSize: keys?.limitFileSizeDefault,
                    label: 'Arquivo',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
